module.exports = __webpack_public_path__ + "img/custom-logo-white.55f0b432.svg";